/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-find-dom-node */
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import Menu from '@tencent/dui/lib/components/Menu';
import styles from './font-family-menu.css';

const firstCount = 40;
const menuStyle = {
    border: 0,
    boxShadow: 'none',
    width: 238,
    backgroundColor: 'transparent',
    backdropFilter: 'none',
    padding: 0,
};

export interface FontFamilyMenuProps {
    data: Array<any>;
    checkSelectedValue?: boolean
    selectedIndex: number;
    onMenuClick?: (id: number) => void;
}

interface FontFamilyMenuState {
    listData: Array<any>;
}

/**
 * 优化渲染方式，分批渲染字体
 */
export default class FontFamilyMenu extends Component<FontFamilyMenuProps, FontFamilyMenuState> {
    private menuDom: HTMLDivElement|null;
    private timer: NodeJS.Timeout|null;
    public constructor(p: FontFamilyMenuProps) {
        super(p);

        let listData: Array<any> = [];

        // 前40渲染正常数据，后40渲染无字体数据（防止用户打开就快速滑动看到空白），最后延迟渲染剩下的数据
        if (p.data && p.data.length > firstCount) {
            for (let i = 0; i < p.data.length; i++) {
                if (i < firstCount) {
                    listData.push(p.data[i]);
                } else {
                    // if(i<firstCount*2){
                    //     listData.push(p.data[i].content);
                    // }else{
                    //     listData.push(null);
                    // }
                    listData.push(null);
                }
            }
        } else {
            listData = p.data;
        }

        this.state = {
            listData,
        };
    }

    public componentDidMount() {
        if (this.menuDom) {
            const menu = findDOMNode(this.menuDom);
            // 确保第一次dom元素真正挂载成功，否则react有可能把这次挂载和上次合并。
            const rect = (menu as Element)?.getBoundingClientRect();
            const w = rect.width;
            if (w > 0) {
                this.loadItemDelay();
            }
        } else {
            this.loadItemDelay();
        }
    }

    public componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }


    public render() {
        const { props } = this;

        return (
            <div
                ref={(ref) => {
                    this.menuDom = ref;
                }}
                style={{ height: '100%' }}
            >
                <Menu
                    selectable={props.checkSelectedValue}
                    selectedIds={[String(props.selectedIndex)]}
                    style={menuStyle}
                    className="menu-scroll"
                >
                    {this.state.listData.map((itemData, i) => {
                        if (!itemData) {
                            return <div style={{ height: 36 }} key={`${i}`}></div>;
                        }

                        return (
                            <Menu.Item id={String(i)} key={i} onClick={() => this.handleMenuClick(String(i))}>
                                {typeof itemData === 'object' ? (
                                    <span
                                        className={`${styles['item-span']} font-family-menu-item-span-for-e2e-locate`}
                                        style={{ fontFamily: this.convert2Compatible(itemData.id), fontSize: 14 }}
                                        title={itemData.content}
                                    >{itemData.content}</span>
                                ) : (
                                    itemData
                                )}
                            </Menu.Item>
                        );
                    })}
                </Menu>
            </div>
        );
    }

    private loadItemDelay = () => {
        const { listData } = this.state;
        const p = this.props;
        this.timer = setTimeout(() => {
            this.timer = null;
            for (let i = firstCount; i < p.data.length; i++) {
                listData[i] = p.data[i];
            }
            this.setState({
                listData,
            });
        }, 350);
    };

    private handleMenuClick = (id) => {
        if (this.props.onMenuClick) {
            this.props.onMenuClick(parseInt(id, 10));
        }
    };

    // 兼容企微浏览器，toolbar迁移workbench后此文件将删除
    private convert2Compatible = (fontFamily) => {
        if (fontFamily === 'Microsoft YaHei') {
            // eslint-disable-next-line @tencent/i18next/no-literal-string
            return 'Microsoft YaHei, 微软雅黑, Roboto, sans-serif';
        }
        return fontFamily;
    };
}
